export default __webpack_public_path__ + "static/media/SF-Pro-Display-Regular.d9591982.otf";